module.exports = __webpack_public_path__ + "images/icon_autoplay_horizontal_c6f0a8a6dbafc7f6c97aa83ade187586.svg";